import Blue from "~/core";
import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

new Blue({
	name: 'Timeline Slider',
	selector: ".timeline",
	setup(container) {
    // Swiper.use() is no longer needed in Swiper 9+

		const randInt = Math.ceil((Math.random() * 1000) * (Math.random() * 1000));
		console.log("randInt", randInt);
		const swiperContainer = container.querySelector(".timeline__inner");
		const swiperTrack = container.querySelector(".timeline__items");
		const items = [...document.querySelectorAll(".timeline__item")];
		const pagination = container.querySelector(".timeline__pagination");
		const prevBtn = container.querySelector(".timeline__prev");
		const nextBtn = container.querySelector(".timeline__next");

		const skipLink = document.createElement("a");
		skipLink.classList.add("timeline__skip-link");
		skipLink.textContent = "Skip carousel content";
		const skipElement = document.createElement("span");
		skipElement.classList.add("visually-hidden");
		skipElement.id = `skip-${randInt}`;
		skipLink.href = `#skip-${randInt}`;
		container.insertAdjacentElement("afterbegin", skipLink);
		container.insertAdjacentElement("beforeend", skipElement);

		swiperContainer.id = `swiper-${randInt}`;
		swiperContainer.classList.add("swiper");
		pagination.id = `pagination-${randInt}`;
		pagination.classList.add("swiper-pagination");
		swiperTrack.classList.add("swiper-wrapper");
		prevBtn.classList.add("swiper-button-prev");
		nextBtn.classList.add("swiper-button-next");
		prevBtn.id = `prev-${randInt}`;
		nextBtn.id = `next-${randInt}`;
		items.forEach(item => item.classList.add("swiper-slide"));


    const swiper = new Swiper(swiperContainer, {
      modules: [Navigation, Pagination, A11y],
      direction: 'horizontal',
      breakpoints: {
          1: {
              slidesPerView: 1,
							slidesPerGroup: 1,
          },
          769: {
            slidesPerView: 2,
						slidesPerGroup: 2,
            spaceBetween: 30,
          },
          993: {
              slidesPerView: 3,
							slidesPerGroup: 3,
              spaceBetween: 45,
          }
        },
      loop: false,
			pagination: {
				el: `#pagination-${randInt}`,
				type: "bullets",
				clickable: true,
			},
      navigation: {
          nextEl: `#next-${randInt}`,
          prevEl: `#prev-${randInt}`,
      },
    });
	}
});